import React from "react";
import InputField from "../../Forms/Input/InputField";
import DatePicker from "../../Forms/DatePicker/DatePicker";
import { ProductFormValues } from "../../../types/product/ProductFormValues";
import { useProduct } from "../../../hooks/useProduct";

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductTraceability: React.FC<Props> = ({ form, onChange }) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

      {/* Número de Lote */}
      <InputField
        label="Número de Lote:"
        name="lotNumber"
        type="text"
        iconKey="barcode"
        value={form.lotNumber ?? ""}
        onChange={(e) => onChange("lotNumber", e.target.value)}
        placeholder="Ej: Lote-021-A"
        error={formErrors.lotNumber}
      />

      {/* Batch */}
      <InputField
        label="Batch:"
        name="batch"
        type="text"
        iconKey="layers"
        value={form.batch ?? ""}
        onChange={(e) => onChange("batch", e.target.value)}
        placeholder="Identificador interno de producción"
        error={formErrors.batch}
      />

      {/* Fecha de Expiración */}
      <DatePicker
        label="Fecha de Expiración:"
        name="expirationDate"
        value={form.expirationDate ?? ""}
        onChange={(date) => onChange("expirationDate", date)}
        placeholder="YYYY-MM-DD"
        error={formErrors.expirationDate}
        iconKey="calendar"
      />
    </div>
  );
};

export default ProductTraceability;
